<div class="divide-s300 flex select-none flex-col divide-y">
  <div
    *ngFor="let filter of report.fields; let filterIndex = index"
    class="flex flex-row items-start justify-start"
    [ngClass]="{
      'pt-6': filterIndex !== 0
    }"
  >
    <div class="flex flex-row items-start justify-center">
      <button
        class="hover:bg-m200 text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
        (click)="deleteFilter(filter)"
      >
        <m-trash-icon></m-trash-icon>
      </button>

      <div class="mb-5 ml-5 mt-2 flex flex-col items-start justify-start">
        <div class="text-left font-semibold">{{
          filter.label | capitalizeWords
        }}</div>
      </div>
    </div>

    <div>
      <div
        class="flex flex-row items-start justify-start"
        *ngFor="
          let fraction of filter.fractions;
          let isFirst = first;
          let fractionIndex = index
        "
      >
        <m-fraction
          [suggestModelDimension]="filter.suggestModelDimension"
          [structId]="report.structId"
          [reportId]="report.reportId"
          [fieldResult]="
            !!filter.storeResult ? filter.storeResult : filter.result
          "
          [fieldTimeframe]="undefined"
          [storeContent]="getStoreContent(filter.storeModel)"
          [metricsStartDateYYYYMMDD]="report?.metricsStartDateYYYYMMDD"
          [metricsEndDateYYYYMMDD]="
            getMetricsEndDateYYYYMMDD(filter.storeModel)
          "
          [isMetricsPage]="true"
          [fraction]="fraction"
          [fractionIndex]="fractionIndex"
          [isFirst]="isFirst"
          (fractionUpdate)="fractionUpdate(filter, filterIndex, $event)"
        >
        </m-fraction>

        <div
          tp="Filter max_fractions reached"
          [tpIsEnabled]="
            !!filter.maxFractions &&
            filter.maxFractions === filter.fractions.length
          "
        >
          <button
            class="ml-3 flex h-9 w-9 items-center justify-center rounded focus:outline-none"
            [ngClass]="{
              'hover:bg-m200 text-s500':
                !filter.maxFractions ||
                filter.maxFractions !== filter.fractions.length,
              'text-s400 cursor-default':
                !!filter.maxFractions &&
                filter.maxFractions === filter.fractions.length
            }"
            [disabled]="
              !!filter.maxFractions &&
              filter.maxFractions === filter.fractions.length
            "
            (click)="addFraction(filter, filterIndex)"
          >
            <m-add-icon></m-add-icon>
          </button>
        </div>

        <button
          class="hover:bg-m200 text-s500 ml-3 flex h-9 w-9 items-center justify-center rounded focus:outline-none"
          (click)="deleteFraction(filter, filterIndex, fractionIndex)"
        >
          <m-trash-icon></m-trash-icon>
        </button>
      </div>
    </div>
  </div>
</div>
